var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSauna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3335 58.8029C54.8891 46.141 65.4444 49.8467 76.0002 59.1112C86.5559 68.3754 97.1111 72.0816 107.667 59.4194M44.3335 92.5807C54.8891 79.9185 65.4444 83.6248 76.0002 92.8892C86.5559 102.154 97.1111 105.859 107.667 93.197",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3335 58.8029C54.8891 46.141 65.4444 49.8467 76.0002 59.1112C86.5559 68.3754 97.1111 72.0816 107.667 59.4194M44.3335 92.5807C54.8891 79.9185 65.4444 83.6248 76.0002 92.8892C86.5559 102.154 97.1111 105.859 107.667 93.197",
    stroke: "url(#paint0_linear_16725_940)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9998 139.333C110.978 139.333 139.333 110.978 139.333 76.0001C139.333 41.022 110.978 12.6667 75.9998 12.6667C41.0218 12.6667 12.6665 41.022 12.6665 76.0001C12.6665 110.978 41.0218 139.333 75.9998 139.333Z",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9998 139.333C110.978 139.333 139.333 110.978 139.333 76.0001C139.333 41.022 110.978 12.6667 75.9998 12.6667C41.0218 12.6667 12.6665 41.022 12.6665 76.0001C12.6665 110.978 41.0218 139.333 75.9998 139.333Z",
    stroke: "url(#paint1_linear_16725_940)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_940",
    x1: 44.3335,
    y1: 50.6667,
    x2: 116.552,
    y2: 76.3759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_940",
    x1: 12.6665,
    y1: 12.6667,
    x2: 163.198,
    y2: 55.5373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauna);
export default __webpack_public_path__ + "static/media/sauna.4fbaca20d340aca38176402489f00c6e.svg";
export { ForwardRef as ReactComponent };